import React, { FC } from 'react';
import { Box, Button, Container, Modal } from '@mui/material';
import Typography from '@mui/material/Typography';
import { colors } from '../../colors/Colors';
import { ModalAction } from '../../model/Types';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (action: ModalAction) => void;
    text: string;
    action: ModalAction;
    isMobile?: boolean;
}

export const ConfirmationModalComponent: FC<ConfirmationModalProps> = ({
    open,
    onClose,
    text,
    onConfirm,
    action,
    isMobile,
}) => {
    const { t } = useTranslation();

    const onYesClicked = () => {
        onConfirm(action);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 300 : 460,
        backgroundColor: colors.background,
        border: '2px solid #2C2C2C',
        borderRadius: '1.5rem',
        boxShadow: 24,
        p: 4,
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={modalStyle}>
                <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    color={colors.accent}
                >
                    {text}
                </Typography>
                <Container
                    sx={{
                        paddingTop: '20px',
                        display: 'flex',
                        gap: '40px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Button
                        onClick={onYesClicked}
                        variant="contained"
                        style={{ backgroundColor: colors.primary }}
                    >
                        {t('modals.yes')}
                    </Button>
                    <Button
                        onClick={onClose}
                        variant="contained"
                        style={{ backgroundColor: colors.primary }}
                    >
                        {t('modals.no')}
                    </Button>
                </Container>
            </Box>
        </Modal>
    );
};
